import React, { Component } from 'react';

import { reduxForm } from 'redux-form';

import withAuthControl from '../auth/Auth.js';

import Section from './Section.js';
import CustomSpinner from './CustomSpinner.js';
import CustomAlertModal from './CustomAlertModal.js';
import SelfieWithDocumentRegister from './SelfieWithDocumentRegister.js';
import SelfieWithDocumentIntroduction from './SelfieWithDocumentIntroduction.js';


const PHOTO_STEPS = [
    'register',
    'introduction',
];

class SelfieWithDocument extends Component {
  constructor(props){
    super(props);

    this.state = {
        attempt: 1,
        processedSteps: [],
        currentStep: PHOTO_STEPS.pop(),
        missingSteps: [...PHOTO_STEPS],
        incompatibleSettings: false,
    }

    this.resetSteps = this.resetSteps.bind(this);
    this.updateStep = this.updateStep.bind(this);
    this.checkBrowserCompatibility = this.checkBrowserCompatibility.bind(this);
  }

  componentDidMount(){
    let body = document.getElementsByTagName("BODY")[0];
    body.style.position = "fixed";
    this.checkBrowserCompatibility();
  }

  componentWillUnmount(){
    let body = document.getElementsByTagName("BODY")[0];
    body.style.position = "inherit";
  }

  updateStep(){
    let { currentStep, missingSteps, processedSteps } = this.state;
    this.setState({
      ...this.state,
      processedSteps:[
        ...processedSteps,
        currentStep,
      ],
    });

    if(missingSteps.length === 0){

      this.props.dispatch(this.props.getStep({}, this.props.dispatch));
    }

    this.setState({
      ...this.state,
      currentStep: missingSteps.pop(),
      missingSteps: [
        ...missingSteps
      ]
    });
  }

  checkBrowserCompatibility(){
    if(/iPhone|iPad/.test(navigator.userAgent)){
      if(!/Version\//.test(navigator.userAgent)){
        this.setState({
          ...this.state,
          incompatibleSettings: true,
        })
      }
    }
  }

  resetSteps(){
    this.setState({
      attempt: this.state.attempt + 1,
      processedSteps: [],
      currentStep: 'introduction',
      missingSteps: [...PHOTO_STEPS],
    });

    this.props.dispatch(this.props.getStep({}, this.props.dispatch));
  }

  render() {
    const { currentStep, incompatibleSettings, attempt } = this.state;

    let stepComponent = null;


    switch(currentStep){
      case('introduction'):
          stepComponent = (<SelfieWithDocumentIntroduction onFinish={this.updateStep}/>)
          break;
      case('register'):
          stepComponent = (<SelfieWithDocumentRegister onFinish={this.updateStep} onRollback={this.resetSteps} key={attempt}/>)
          break;
      default:
          stepComponent = '';
    }

    return (
    <Section className="intro_form">
        {this.props.isLoading && <CustomSpinner message='Estamos analizando su solicitud. Por favor espere...' /> }
        <div className="row">
            <div className="pd-content-right col-sm-12 col-md-12 col-lg-12">
                <form  className="pvc-form">
                    <div style={{
                        position: "fixed",
                        left: 0,
                        top: 0,
                        height: "100vh",
                        width: "100%",
                        background: "#000",
                        zIndex: "1000"
                    }} >
                        {stepComponent}
                        {incompatibleSettings && (<CustomAlertModal>
                          Para poder acceder a la cámara de su dispositivo necesitamos que por favor reingrese desde Safari
                        </CustomAlertModal>)}
                    </div>
                </form>
            </div>
        </div>
    </Section>)

  }
}


SelfieWithDocument = reduxForm({
    form: 'SelfieWithDocument', // a unique name for this form
})(SelfieWithDocument);

SelfieWithDocument = withAuthControl(SelfieWithDocument);

export default SelfieWithDocument;



/** WEBPACK FOOTER **
 ** ./src/components/SelfieWithDocument.js
 **/